import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { IonApp, IonIcon, IonRouterOutlet } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  logOutOutline,
  personOutline,
  lockClosedOutline,
  logInOutline,
  homeOutline,
  settingsOutline,
  helpCircleOutline,
  gridOutline,
  barChartOutline,
  peopleOutline,
  folderOpenOutline,
  documentOutline,
  chatbubbleOutline,
  notificationsOutline,
  businessOutline,
  personAddOutline,
  documentTextOutline,
  statsChartOutline
} from 'ionicons/icons';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [
    CommonModule,
    IonIcon,
    IonApp,
    IonRouterOutlet
  ]
})
export class AppComponent implements OnInit {
  showSidebar = true;

  constructor(private router: Router, private cdr: ChangeDetectorRef) {
    // Register all icons used in the sidebar
    addIcons({
      'log-out-outline': logOutOutline,
      'person-outline': personOutline,
      'lock-closed-outline': lockClosedOutline,
      'log-in-outline': logInOutline,
      'home-outline': homeOutline,
      'settings-outline': settingsOutline,
      'help-circle-outline': helpCircleOutline,
      'grid-outline': gridOutline,
      'bar-chart-outline': barChartOutline,
      'people-outline': peopleOutline,
      'folder-open-outline': folderOpenOutline,
      'document-outline': documentOutline,
      'chatbubble-outline': chatbubbleOutline,
      'notifications-outline': notificationsOutline,
      'business-outline': businessOutline,
      'person-add-outline': personAddOutline,
      'document-text-outline': documentTextOutline,
      'stats-chart-outline': statsChartOutline
    });
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateSidebarVisibility();
    });
  }

  ngOnInit() {
    // Subscribe to router events to handle focus management
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Remove focus from any focused elements after navigation
      const activeElement = document.activeElement as HTMLElement;
      if (activeElement) {
        activeElement.blur();
      }
    });
    // Set initial sidebar state
    this.updateSidebarVisibility();
  }

  updateSidebarVisibility() {
    const hiddenRoutes = ['/login', '/set-initial-password', '/change-password'];
    this.showSidebar = !hiddenRoutes.includes(this.router.url);
    this.cdr.detectChanges();
  }
}
